<template>
  <div class="full-page-loader position-fixed">
    <div class="vh-center position-absolute z-1 load-round">
      <b-spinner variant="primary"></b-spinner>
      <!--<img src="@/assets/img/theme/loader.gif" alt="loading...">-->
    </div>
    <div class="full-load-text position-absolute d-none">
      Upgrading your plan ...
    </div>
  </div>
</template>
<script>
export default {
  name: "McFullPageLoader",
};
</script>
